import Component from 'gia/Component';
import CursorFollow from '../fx/CursorFollow';
import { RevealFade } from '../fx/Common';

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.cursor = new CursorFollow(this.DOM.view,{'type':'basic'})
    RevealFade(this.DOM.view)
  }

  unmount()
  {

  }
}
